module.exports = __webpack_public_path__ + "img/Final Model V2.66f14ef6.jpg";